import { CHARACTER_DIRECTION } from "common/model";
import { buildMap, WALL, FLOOR, CHAR, BOX, GOAL } from "./template";

const layer1 = [
  [WALL, WALL, WALL, WALL, WALL],
  [WALL, FLOOR, FLOOR, FLOOR, WALL],
  [WALL, FLOOR, FLOOR, FLOOR, WALL],
  [WALL, FLOOR, FLOOR, FLOOR, WALL],
  [WALL, WALL, WALL, WALL, WALL],
];

const layer2 = [
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, GOAL, BOX, CHAR, 0],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
];

export default buildMap(layer1, layer2, CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_Z);
